<template>
  <div class="base-table-loading">
    <el-table :data="data" class="base-table-loading__table">
      <el-table-column v-for="(item, idx) in data" :key="idx" :prop="item.name" :label="item.label">
        <span class="skeleton-box-wrapper">
          <span
            v-for="(cols, id) in item.layout"
            :key="id"
            class="skeleton-box-item"
            :style="{
              'width': cols.width,
              'justify-content': cols.justifyContent || '',
              'align-items': cols.alignItems || '',
              'flex-direction': cols.flexDirection || ''
            }"
          >
            <span
              v-for="(box, id) in cols.items"
              :key="id"
              class="skeleton-box"
              :class="{ 'skeleton-box--rounded': box.type === 'circle' }"
              :style="{ width: box.width || '', height: box.height || '' }"
            >
            </span>
          </span>
        </span>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => ([
        {
          name: "Action",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Class Name",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Teacher",
          label: "",
          layout: [
            {
              width: "30%",
              justifyContent: "center",
              alignItems: "center",
              items: [
                {
                  width: "40px",
                  height: "40px",
                  type: "circle",
                },
              ],
            },
            {
              width: "70%",
              items: [
                {
                  type: "rectangle",
                  width: "60%",
                  height: "12px",
                },
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Accepted Leaners",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Total Learners",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Start Date",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "End Date",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
        {
          name: "Status",
          label: "",
          layout: [
            {
              width: "100%",
              items: [
                {
                  width: "100%",
                  height: "12px",
                  type: "rectangle",
                },
              ],
            },
          ],
        },
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.base-table-loading {
  padding: 40px;
}
.skeleton-box-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 100%;
  min-height: 40px;
}
.skeleton-box-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 100%;
  width: 100%;
}
.skeleton-box {
  display: inline-block;
  height: 1em;
  position: relative;
  overflow: hidden;
  background-color: #dddbdd;

  &--rounded {
    border-radius: 50%;
  }

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.2) 20%, rgba(#fff, 0.5) 60%, rgba(#fff, 0));
    animation: shimmer 2s infinite;
    content: "";
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>